import * as React from 'react';
import cx from 'classnames';
import wrapStore from '@src/utils/wrap-store';
import Page from '@src/components/page';
import xauCss from '@src/components/xfe-animation-css';
import Button from '@src/components/button';
import Link from '@src/components/link';
import Store from './store';
import { $$tracker } from '@src/tracker';
import BacktopFooter from '@src/business-components/backtop-footer';
import getLanguageByPath from '@src/utils/locale/getLanguageByPath';
const lang = getLanguageByPath();

const styles = require('./index.less');

const isShowDownloadBtn = link => {
  return link && link !== 'hidden';
};

const Download = ({ store }) => {
  const { layerData = {} } = store;
  const { download = {} } = layerData;
  store.use();

  return (
    <Page className={cx(styles.root, store.isActive && xauCss.AOS_ROOT)}>
      <Button className={styles.btnBack} onClick={store.back} style={{ backgroundImage: `url(${require(`./images/${lang}/btn-back.png`)})` }} />
      <div
        className={cx(styles.title, styles.bigTitle, { ...xauCss.AOS_FADE.IN_UP.FAST_DELAY(1) })}
        style={{ backgroundImage: `url(${require(`./images/${lang}/title.png`)})` }}
      />
      <section ref={store.scrollBox} className={styles.wrapper}>
        {/* 下载方式 */}
        <section className={cx(styles.downloadMethod, { ...xauCss.AOS_FADE.IN_UP.FAST_DELAY(3) })}>
          <div className={styles.layoutRow}>
            {isShowDownloadBtn(download.launcher_download_link) ? (
              <div className={styles.btnDownload}>
                <Link
                  onClick={() => $$tracker.clickDownloadPC()}
                  style={{ backgroundImage: `url(${require(`./images/${lang}/btn-download-pc.png`)})` }}
                  href={download.launcher_download_link}
                />
              </div>
            ) : null}
            {isShowDownloadBtn(download.steam_download_link) ? (
              <div className={styles.btnDownload}>
                <Link
                  onClick={() => $$tracker.clickDownloadSteam()}
                  style={{ backgroundImage: `url(${require(`./images/${lang}/btn-download-steam.png`)})` }}
                  href={download.steam_download_link}
                />
              </div>
            ) : null}
          </div>
          <div className={styles.layoutRow}>
            {isShowDownloadBtn(download.xbox_download_link) ? (
              <div className={styles.btnDownload}>
                <Link
                  onClick={() => $$tracker.clickDownloadXbox()}
                  style={{ backgroundImage: `url(${require(`./images/${lang}/btn-download-xbox.png`)})` }}
                  href={download.xbox_download_link}
                />
              </div>
            ) : null}
            {isShowDownloadBtn(download.gpg_download_link) ? (
              <div className={styles.btnDownload}>
                <Link
                  onClick={() => $$tracker.clickDownloadGPG()}
                  style={{ backgroundImage: `url(${require(`./images/${lang}/btn-download-google-play.png`)})` }}
                  href={download.gpg_download_link}
                />
              </div>
            ) : null}
          </div>
        </section>
        <div className={cx(styles.divider, { ...xauCss.AOS_FADE.IN_UP.FAST_DELAY(1) })} />
        {/* 安装常见问题 */}
        <section className={styles.installerQuestion}>
          <div
            style={{ backgroundImage: `url(${require(`./images/${lang}/title-installer-question.png`)})` }}
            className={cx(styles.subTitle, { ...xauCss.AOS_FADE.IN_UP.FAST_DELAY(1) })}
          />
          <div className={cx(styles.content, { ...xauCss.AOS_FADE.IN_UP.FAST_DELAY(3) })}>
            {store.installerQuestion.map((item, index) => (
              <div key={index} className={styles.link}>
                <Link href={item.link[lang]} target="_blank">
                  {item.title}
                </Link>
              </div>
            ))}
          </div>
        </section>
        {/* 推荐配置 */}
        <section className={styles.recommConfig}>
          <div
            style={{ backgroundImage: `url(${require(`./images/${lang}/title-recom-config.png`)})` }}
            className={cx(styles.subTitle, { ...xauCss.AOS_FADE.IN_UP.FAST_DELAY(1) })}
          />
          <div className={cx(styles.content, { ...xauCss.AOS_FADE.IN_UP.FAST_DELAY(3) })}>
            <div className={styles.configTable} style={{ backgroundImage: `url(${require(`./images/${lang}/config-table.png`)})` }} />
          </div>
        </section>
        {/* 显示驱动程序下载 */}
        <section className={styles.graphicsCardInstaller}>
          <div
            style={{ backgroundImage: `url(${require(`./images/${lang}/title-graphics-card-installer.png`)})` }}
            className={cx(styles.subTitle, { ...xauCss.AOS_FADE.IN_UP.FAST_DELAY(1) })}
          />
          <div className={cx(styles.content, { ...xauCss.AOS_FADE.IN_UP.FAST_DELAY(3) })}>
            {store.graphicsCardInstallerPackage.map((item, index) => (
              <Link className={cx(styles.installerPackage, styles[item.title])} href={item.link[lang]} target="_blank">
                <img src={item.icon} className={styles.icon} alt={item.title} />
              </Link>
            ))}
          </div>
        </section>
      </section>
      <BacktopFooter position="fixed" onBackTop={store.onBackTop} showBtnBackTop={store.isShowBackTop} />
    </Page>
  );
};

export default wrapStore(Download, Store);
